class CustomAnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var autoplay = $(this).data("autoplay");
      var effect = $(this).data("effect");
      var speedtime = $(this).data("speedtime");

      var swiper = new Swiper(
        ".custom-announcement--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 30,
          effect: effect,
          fadeEffect: { crossFade: true },
          autoplay: {
            enabled: autoplay,
            delay: speedtime,
            disableOnInteraction: false,
          },
          loop: autoplay,
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-announcement-slider", CustomAnnouncementBar);

class CustomImageTextBox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var autoplay = $(this).data("autoplay");
      var slideperrow = $(this).data("logoperrow");
      var slideperrowmob = $(this).data("logoperrowmob");

      var swiper = new Swiper(
        ".customimagetextboxslider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: slideperrowmob,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: autoplay,
          loop: autoplay,
          breakpoints: {
            640: {
              slidesPerView: slideperrowmob,
            },
            768: {
              slidesPerView: slideperrow - 1,
            },
            1024: {
              slidesPerView: slideperrow - 1,
            },
            1441: {
              slidesPerView: slideperrow,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-image-text-box", CustomImageTextBox);

class CustomLogoSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var autoplay = $(this).data("autoplay");
      var slideperrow = $(this).data("logoperrow");
      var slideperrowmob = $(this).data("logoperrowmob");

      var swiper = new Swiper(
        ".customlogoimages--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: slideperrowmob,
          spaceBetween: 25,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          autoplay: {
            enabled: autoplay,
            delay: 0,
            disableOnInteraction: false,
          },
          speed: 2500,
          loop: autoplay,
          breakpoints: {
            640: {
              slidesPerView: slideperrowmob,
              spaceBetween: 25,
            },
            768: {
              slidesPerView: slideperrow - 2,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: slideperrow - 1,
              spaceBetween: 40,
            },
            1441: {
              slidesPerView: slideperrow,
              spaceBetween: 80,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-logo-slider", CustomLogoSlider);

class CustomLogoSliderproduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var autoplay = $(this).data("autoplay");
      var slideperrow = $(this).data("logoperrow");
      var slideperrowmob = $(this).data("logoperrowmob");

      var swiper = new Swiper(
        ".customlogoimages--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: "auto",
          spaceBetween: 25,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          autoplay: {
            enabled: autoplay,
            delay: 0,
            disableOnInteraction: false,
          },
          speed: 3500,
          loop: autoplay,
          freeMode: autoplay,
          breakpoints: {
            640: {
              slidesPerView: "auto",
              spaceBetween: 25,
            },
            768: {
              slidesPerView: "auto",
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: "auto",
              spaceBetween: 40,
            },
            1441: {
              slidesPerView: "auto",
              spaceBetween: 50,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-logo-slider-product", CustomLogoSliderproduct);

class CustomTab extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(document).ready(function () {
        var title = $(".custom_tab_heading").eq(0).data("blockid");
        $(".custom_tab_heading").eq(0).addClass("activetab");
        $('.custom_tab_content[data-block="' + title + '"]').show();
        $(".bottom-content-images-wrapper")
          .find('.swiper-slide[data-blockid="' + title + '"]')
          .hide();

        $(".custom_tab_heading").click(function () {
          $(".custom_tab_heading").removeClass("activetab");
          $(this).addClass("activetab");
          var title = $(this).data("blockid");
          $(".custom_tab_content").hide();
          $('.custom_tab_content[data-block="' + title + '"]').show();
          $(".bottom-content-images-wrapper").find(".swiper-slide").show();
          $(".bottom-content-images-wrapper")
            .find('.swiper-slide[data-blockid="' + title + '"]')
            .hide();
        });

        var count = $(this).find('.header-slider').data('count');

        console.log("count=="+count);

        if(count > 5){
                  var swiper = new Swiper(".header-slider", {
          slidesPerView: 'auto',
          spaceBetween: 0,
          freeMode: true,
          slideToClickedSlide: true,
          navigation: {
            nextEl: ".header-button-next",
            prevEl: ".header-button-prev",
          },
          updateOnWindowResize: true,
          centeredSlides: true,
          centeredSlidesBounds: true,
          initialSlide: 0,
          on: {
            click() {
              console.log("index", this.clickedIndex);
              mySwiper.slideTo(this.clickedIndex);
            },
          },
          breakpoints: {
            640: {
              slidesPerView: 'auto',
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 'auto',
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 'auto',
              spaceBetween: 0,
            },
          },
        });          
       }else{
          var swiper = new Swiper(".header-slider", {
          slidesPerView:3,
          spaceBetween: 0,
          freeMode: true,
          slideToClickedSlide: true,
          navigation: {
            nextEl: ".header-button-next",
            prevEl: ".header-button-prev",
          },
          updateOnWindowResize: true,
          centeredSlides: true,
          centeredSlidesBounds: true,
          initialSlide: 0,
          on: {
            click() {
              console.log("index", this.clickedIndex);
              mySwiper.slideTo(this.clickedIndex);
            },
          },
          breakpoints: {
            640: {
              slidesPerView:3,
              spaceBetween: 0,
            },
            735: {
              slidesPerView: 4,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 0,
            },
          },
        });
       }

        var swiper = new Swiper(".bottom-image-slider", {
          slidesPerView: 3,
          spaceBetween: 15,
          pagination: {
            el: ".bottom-image-pagination",
            clickable: true,
          },
        });
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-tab", CustomTab);
